import React, { useContext } from "react";

import Clock from "../../../../../../../../global/Clock";
import Flag from "../Flag";
import "./BaseField.css";
import { StaticBarStateContext } from "../../../context/StaticBarContext";
import LabelText from "../LabelText";

import { styled, Tooltip, tooltipClasses } from "@mui/material";

import { TooltipStyling } from "../../utils/TooltipStyling";

import cx from "classnames";
import PropTypes from "prop-types";

export default function BaseField({
  fieldName,
  id,
  testId,
  label,
  flag,
  clock,
  customFontSize,
  children,
  contentClassName,
  customLabelFontSize,
}) {
  const state = useContext(StaticBarStateContext);
  const generateCustomLineHeight = (value) => {
    const reg = /\d+/;
    const origLineHeight = value.match(reg);
    const newLineHeight = parseInt(origLineHeight[0]) + 3;
    return newLineHeight + "px";
  };
  const HtmlInfoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: TooltipStyling,
  }));

  return (
    <div className="w-full">
      {state?.ui[fieldName] && state?.ui[fieldName].isLoading ? (
        <div className="loader"></div>
      ) : (
        <HtmlInfoTooltip
          title={
            state?.ui?.[fieldName]?.tooltips?.title ||
            (state?.ui?.[fieldName]?.tooltips?.description && (
              <>
                {state?.ui?.[fieldName]?.tooltips?.title && (
                  <div>{state?.ui?.[fieldName]?.tooltips?.title}</div>
                )}
                {state?.ui?.[fieldName]?.tooltips?.description && (
                  <div>
                    <hr />
                    {state?.ui?.[fieldName]?.tooltips?.description}
                  </div>
                )}
              </>
            ))
          }
        >
          <div id={id} data-testid={testId} className="text-base-[6px] mb-2">
            <div className="flex">
              <div className="m-0 w-[95%] p-0">
                {label && <LabelText label={label} customLabelFontSize={customLabelFontSize} />}
              </div>
              <div className="m-0 w-[5%] p-0">
                {flag && (
                  <Flag
                    fieldName={fieldName}
                    flagValue={flag}
                    tooltipTitle={state?.ui?.[fieldName]?.tooltips?.flag_state_tooltip_title}
                    tooltipDesc={state?.ui?.[fieldName]?.tooltips?.flag_state_tooltip_description}
                    tooltipObj={state?.ui?.[fieldName]?.tooltips?.flag_state_tooltip}
                  />
                )}
              </div>
            </div>

            <div className="flex">
              <div
                className={cx("text-[16px]", contentClassName)}
                style={{
                  fontSize: customFontSize ? customFontSize : "16px",
                  lineHeight: customFontSize ? generateCustomLineHeight(customFontSize) : "18px",
                }}
              >
                {children}
              </div>
              {clock && (
                <Clock
                  fieldName={fieldName}
                  clockValue={clock}
                  tooltipTitle={state?.ui?.[fieldName]?.tooltips?.clock_state_tooltip_title}
                  tooltipDesc={state?.ui?.[fieldName]?.tooltips?.clock_state_tooltip_description}
                  tooltipObj={state?.ui?.[fieldName]?.tooltips?.clock_state_tooltip}
                />
              )}
            </div>
          </div>
        </HtmlInfoTooltip>
      )}
    </div>
  );
}

BaseField.prototypes = {
  contentClassName: PropTypes.string,
};
